var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"shrink mt-1 cursor-mouse",attrs:{"alt":"eHorseSale logo","contain":"","min-width":_vm.minWidth,"src":"https://www.ehorsesale.com/images/ehorsesale/blackbox.png","width":"100"},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }